var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8C2.44772 8 2 8.44772 2 9V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V9C22 8.44772 21.5523 8 21 8H3ZM0 9C0 7.34315 1.34315 6 3 6H21C22.6569 6 24 7.34315 24 9V23C24 24.6569 22.6569 26 21 26H3C1.34315 26 0 24.6569 0 23V9Z",
    fill: "#0063D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.34 11.6306L24 13.6866V17.3134L29.34 19.3694C29.4239 19.3957 29.5357 19.3913 29.6812 19.2511C29.8428 19.0954 30 18.794 30 18.38V12.62C30 12.206 29.8428 11.9046 29.6812 11.7489C29.5357 11.6087 29.4239 11.6043 29.34 11.6306ZM31.0688 10.3086C31.6572 10.8754 32 11.714 32 12.62V18.38C32 19.286 31.6572 20.1246 31.0688 20.6914C30.47 21.2683 29.5847 21.5741 28.6696 21.2539L28.6551 21.2488L22 18.6866V12.3134L28.6551 9.75124L28.6696 9.74614C29.5847 9.42586 30.47 9.73172 31.0688 10.3086Z",
    fill: "#0063D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C10 12.4477 10.4477 12 11 12H17C17.5523 12 18 12.4477 18 13C18 13.5523 17.5523 14 17 14H11C10.4477 14 10 13.5523 10 13Z",
    fill: "#0063D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b84ed4e3d1ec2dcac90ba0b085318677.svg";
export { ForwardRef as ReactComponent };